<template>
    <div>
        <base-crud
                crudName="Domínios"
                newText="Novo Domínio"
                :table="domainTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="false"
                :enableDelete="true"
                :enableView="false"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                domainTable: 'domainTable',
                teams: [],
                pages: [],
                url: '',
                columns: ['id', 'domain', 'tenant_id', 'actions'],
                tableData: ['id', 'domain', 'tenant_id'],
                options: {
                    filterable:[],
                    filterByColumn: true,                   
                    sortable: [],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',
                        'domain' : 'Domínio',
                        'tenant_id' : 'Tenant',
                        'actions' : 'Ações'
                    },
                    requestFunction: function(data) {
                      let requestData = {};

                       let query = this.$parent.$parent.query(data.query);
                       requestData.params = data;
                       requestData.params.query = "";
                       requestData.params.with = [];

                      return this.$http
                          .get(this.url + '?' + query, requestData)
                          .catch(
                              function(e) {
                                  this.dispatch("error", e);
                              }.bind(this)
                          );
                    },
                },
                endPoint: 'domains/'
            }
        },
        methods: {
          query: function (query) {
            let columns = {
              id: 'id',
              tenant_id: 'tenant_id',
              domain: 'domain',
            };
            let filters = "";
            $.each(query, function (index, value) {
              filters += columns[index] + "=" + value + "&";
            });
    
               return filters;
          }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Domains/Crud.vue